import { Platform } from 'react-native';
import { Text, TextProps } from '@pletly/ui';

export const UserNameForPost = ({ ...props }: TextProps) => {
	return <Text category={Platform.OS === 'web' ? 'h5' : 'h6'} {...props} />;
};
